var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 156,
    viewBox: "0 0 107 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5454 0.151223C23.3208 1.46339 1.01676 24.2595 0.196752 51.6479C-0.131574 64.7683 4.29681 76.7402 11.8415 86.2523C22.9931 100.193 31.5215 115.937 37.7538 132.665C39.8862 138.406 41.8539 143.981 43.6579 149.229C46.7742 158.249 59.5661 158.249 62.6824 149.229C64.4865 143.98 66.4542 138.404 68.5865 132.665C74.6543 116.101 82.8544 100.357 94.0071 86.7443C101.552 77.5605 106.144 65.9158 106.144 53.1239C106.141 22.9475 81.0489 -1.16079 50.5439 0.151223H50.5454ZM53.1697 89.6964C32.9977 89.6964 16.5972 73.2962 16.5972 53.1239C16.5972 32.9519 32.9974 16.5514 53.1697 16.5514C73.342 16.5514 89.7422 32.9516 89.7422 53.1239C89.7422 73.2959 73.342 89.6964 53.1697 89.6964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6137 29.9995H44.1499C42.3458 29.9995 40.8701 31.4753 40.8701 33.2793V73.9518C40.8701 75.1004 41.854 76.0842 43.0025 76.0842H48.7432C49.8917 76.0842 50.8755 75.1003 50.8755 73.9518V61.9799H57.2716C66.7837 61.9799 74.3273 53.6161 73.0164 43.9391C71.8656 35.9027 64.6494 29.9995 56.6139 29.9995H56.6137ZM57.1056 51.9755H50.7096V40.0036H57.1056C60.3854 40.0036 63.1734 42.6279 63.1734 46.0714C63.1734 49.5149 60.3855 51.9755 57.1056 51.9755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.16602e2b7bf36be32f6154d2b2165a3e.svg";
export { ForwardRef as ReactComponent };